import { gql } from '@apollo/client';

const ME_BASIC_QUERY = gql`
    query Me {
        me {
            rfcs {
                id
                rfc
                businessName
                taxZipCode
                address {
                    streetAddress1
                    externalNumber
                    postalCode
                    cityArea
                    city
                    countryArea
                    country {
                        country
                        code
                    }
                }
            }
            referralCode {
                conditionMessage
                code
                discountType
                referralDiscountMessage
                referralProgramTitle
                referredDiscountMessage
            }
            preferredContactChannelDisplay
            preferredContactChannel
        }
    }
`;

export default ME_BASIC_QUERY;
